module.exports = __webpack_public_path__ + "brand-icons.13db00b7a34fee4d819a.eot";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/brand-icons.eot
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/brand-icons.eot
// module chunks = styles